import ControlModule  from 'scripts/poppet/control-module';
import template       from 'templates/controlSettings.jst.html';
import UnitUserAccess from 'scripts/defa/access-handler/unit-user-access';

/**
 * defa.views.ControlSettingsView
 * A control module for unit settings.
 * @version 1.3.0
 */

const selectors = {
	regionContainer: '[data-region=settings-container]',
	navButtons     : '[data-click^=nav-]',
	toggleButton   : '[data-toggle=expand-spoiler]',
	spoiler        : '[data-container=expand-spoiler]'
};

const channelUser = Bb.Radio.channel( 'user' );
const channelObjects = Bb.Radio.channel( 'objects' );

const ControlSettingsView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template          : template,
	expandedNavState  : 'unit:control:settings',
	compressedNavState: 'unit:control:overview',
	
	className: function () {
		return this._getClassName( 'control-settings' );
	},
	
	// !TODO: These navButtons could populate their targets with the href attribute instead of using events,
	// but not until we've externalized the navHandler map of navEvents, urls, and options, with titles and
	// meta descriptions as well. When that happens, revisit this class.
	
	ui: {
		nav   : selectors.navButtons,
		toggle: selectors.toggleButton,
		spoiler: selectors.spoiler
	},
	
	events: {
		'click @ui.nav'   : 'onClickNav',
		'click @ui.toggle': 'onClickToggle', // super
	},
	
	regions: {
		container: selectors.regionContainer,
	},
	
	templateContext: function () {
		const superContext = ControlModule.prototype.templateContext.call( this );
		const user         = channelUser.request( 'model' );
		return _.extend( superContext, {
			isTechSupport               : user.isTechSupport(),
			hasSubscription             : this.model.hasSubscription(),
			hasUnitControlAccess        : UnitUserAccess.hasUnitControlAccess(this.model, user),
			isOwner                     : UnitUserAccess.isOwner(this.model, user),
			canInstall                  : UnitUserAccess.canInstall(this.model, user),
			showInstall                 : this.showInstallersettings(user, this.model),
			transientSettingsAutomotive : this.model.get('transientSettingsAutomotive'),
			transientSettingsHome       : this.model.get('transientSettingsHome'),
			isAutomotive                : this.model.isAutomotive(),
			isBluetooth                 : this.model.isBluetooth(),
			hasLocation                 : this.options.locationModel !== undefined,
			isPro                       : this.model.isPro(),
			isHome                      : this.model.isHome(),
			isCurrentInstaller          : UnitUserAccess.isCurrentInstaller(this.model, user),
			isConfiguring               : this.model.get( 'transientIsConfiguring' )
		} );
	},
	
	showInstallersettings: function (user, unit) {
		return UnitUserAccess.canInstall( unit, user ) && !this.options.unit.isBluetooth();
	},
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when an end user clicks any of the nav-buttons.
	 * @void
	 */
	onClickNav: function ( event ) {
		let self = this;
		this.busy();
		
		event.preventDefault();
		
		let $target = $( event.target ).closest( selectors.navButtons );
		let command = $target.attr( 'data-click' ).replace( 'nav-', '' );
		
		switch ( command ) {
			
			case 'alias' :
				this.trigger( 'nav', 'unit:alias', [ this.model.get( 'id' ), ] );
				break;
			
			case 'gpai' :
				this.expandClose();
				this.idle();
				this.trigger( 'nav', 'unit:control:gpai', [ this.model.get( 'id' ), ] );
				break;
			
			case 'alarmSwitches' :
				this.expandClose();
				this.idle();
				this.trigger( 'nav', 'unit:control:alarm:settings', [ this.model.get( 'id' ), ] );
				break;
			
			case 'dayAndNight' :
				this.expandClose();
				this.idle();
				this.trigger( 'nav', 'unit:control:dayAndNight', [ this.model.get( 'id' ), ] );
				break;
			
			
			case 'location' :
				this.trigger( 'nav', 'unit:location', [ this.model.get( 'id' ) ] );
				break;
			
			case 'subscription' :
				this.trigger( 'nav', 'subscription:panel', [ this.model.get( 'transientSubscription' ), ] );
				break;
			
			case 'details' :
				this.trigger( 'nav', 'unit:details', [ this.model.get( 'id' ) ] );
				break;
			
			case 'vehicle' :
				this.trigger( 'nav', 'unit:vehicle', [ this.model.get( 'id' ) ] );
				break;
				
			case 'retest' :
				this.model.set( {
					tested           : false,
					transientFirmware: false,
					transientTesting : true,
				} );
				
				this.trigger( 'nav', 'unit:test', [ this.model.get( 'id' ), ] );
				break;
			
			case 'complaint' :
				this.trigger( 'nav', 'unit:complaint', [ this.model.get( 'id' ), ] );
				break;
				
			case 'reset-metadata':
				this.trigger('nav', 'unit:reset', [this.model.get('id') ]);
				break;
				
			case 'install':
				this.trigger( 'nav', 'unit:install', [ this.model.get( 'id' ), ] );
				break;
			
			case 'configure':
				this.expandClose();
				this.model.set('transientIsConfiguring', true);
				this.trigger( 'nav', 'unit:control:overview', [ this.model.get( 'id' ), ] );
				break;
			
			default:
				console.log('unknown nav command', command)
		}
		
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default ControlSettingsView;
